itsoftApp.createModule("numbersAnimate", ["animations"], function () {
    var module = this;

    var initNumbersAnimate = function (el) {
        var numberElements = el.querySelectorAll("[data-number-target]");

        Array.prototype.forEach.call(numberElements, function (numberElement) {
            var numberElementText = parseInt(numberElement.textContent, 10);
            var number = parseInt(numberElement.getAttribute("data-number-target"), 10);
            var options = {
                draw: function (progress) { /* анимируем в зависимости от времени и временной функции */
                    numberElement.textContent = numberElementText + parseInt(progress * (number - numberElementText), 10);
                },
                timing: function(timeFraction) {
                    return 1 - (1 - timeFraction);
                    // return -(Math.cos(Math.PI * timeFraction) - 1) / 2
                },
                complete: function () {
                    numberElement.classList.add("is-completed");
                },
                duration: 3000
            }
            itsoftApp.modules.animations.callback(options);
        });
   };

   module.init = initNumbersAnimate;
});